<template>
	<div>
		<template v-for="user in getUsers" v-if="id == user.id">
			<a :href="'/#/user/' + user.id">{{ user.shortened_name }}</a>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'getUsers'
    ])
  }
}
</script>
